import {
  AccreditedGender,
  AppointmentType,
  FilterItem,
  EstablishmentCategory
} from '@/modules/accredited-establishments/api/types'
import { ALL_ID } from '@/modules/accredited-establishments/constants/filters'

interface Filters {
  categories?: EstablishmentCategory[]
  specialty?: FilterItem
  subSpecialty?: FilterItem
  gender?: AccreditedGender
  appointmentType?: AppointmentType
  plan?: FilterItem
  providerName?: string
}

interface makeFiltersArgsReturn {
  categoryIds?: EstablishmentCategory[]
  siteAccreditedNetworkId?: string
  specialtyId?: string
  subSpecialtyId?: string
  gender?: AccreditedGender
  appointmentType?: AppointmentType
  providerName?: string
}

const makeFiltersArgs = (filters: Filters): makeFiltersArgsReturn => {
  const categoryIds = filters.categories?.length
    ? filters.categories
    : undefined
  const siteAccreditedNetworkId =
    filters.plan?.value === ALL_ID ? undefined : filters.plan?.value
  const specialtyId =
    filters.specialty?.value === ALL_ID ? undefined : filters.specialty?.value

  return {
    categoryIds,
    siteAccreditedNetworkId,
    specialtyId,
    ...(filters.subSpecialty
      ? { subSpecialtyId: filters.subSpecialty.value }
      : {}),
    ...(filters.gender ? { gender: filters.gender } : {}),
    ...(filters.appointmentType
      ? { appointmentType: filters.appointmentType }
      : {}),
    providerName: filters.providerName
  }
}

export { makeFiltersArgs }
